module.exports = __webpack_public_path__ + "img/hongbao.79725d0c.png";